import { CurrencyPipe, formatCurrency } from "@angular/common";
import { Component, Inject, LOCALE_ID } from "@angular/core";
import { SubscriptionPlan } from "@apaq/orgkit-js";
import { DialogRef } from "src/app/modules/dialog/dialog-ref";
import { DATA, DIALOG } from "src/app/modules/dialog/dialog.service";

export interface Result {
  email: string;
  role: string;
}

@Component({
  selector: 'ws-invitation-dialog',
  templateUrl: './invitation-dialog.component.html',
  styleUrls: ['./invitation-dialog.component.scss']
})
export class InvitationDialogComponent {

  invitee?: string;
  role: string = 'USER';
  subscriptionPlan?: SubscriptionPlan;
  currency?: string;

  constructor(@Inject(LOCALE_ID) private locale: string, @Inject(DIALOG) private dialogRef: DialogRef, @Inject(DATA) private data: {plan: SubscriptionPlan, currency: string}) {
    this.currency = data.currency;
    this.subscriptionPlan = data.plan;
  }

  get pricePerResource(): string {
    let price = 0.0;
    this.subscriptionPlan?.tiers.forEach(tier => {
      if (tier.upTo == null) {
        price = tier.amount / 100;
      }
    });

    return `${formatCurrency(price, this.locale, this.currency!)}+` + $localize`VAT`;
  }

  hasPricePerResource() {
    return this.subscriptionPlan != null;
  }

  get pricePerResourceDescription() {
    if(!this.hasPricePerResource) {
      return '';
    }
    return $localize`${this.pricePerResource} will be added to your monthly invoice.`;
  }

  cancel() {
    this.dialogRef.close();
  }

  send() {
    const result: Result = {
      email: this.invitee!,
      role: this.role
    }
    this.dialogRef.close(result);
  }
}